<template>
  <the-no-authority v-if="!authority"></the-no-authority>
  <div class="page_box" v-else>
    <!-- <TeacherStudentsMenu></TeacherStudentsMenu> -->
    <!-- 老师信息 -->
    <div class="page_option_box">
      <div class="option_box">
        <input
          type="file"
          id="xlsFile"
          accept=".xls,.xlsx"
          @change="importData($event)"
        />
        <el-button
          type="primary"
          plain
          icon="el-icon-circle-plus-outline"
          size="mini"
          @click="addBox = true"
          >新增</el-button
        >
        <el-button
          style="margin-left:10px"
          type="danger"
          plain
          icon="el-icon-circle-close"
          size="mini"
          @click="delData(rowInfos)"
          :disabled="rowInfos.length < 1 ? true : false"
          >删除</el-button
        >
        <el-button
          type="primary"
          plain
          icon="el-icon-bottom-right"
          size="mini"
          @click="selectFileImport()"
          >导入</el-button
        >
        <el-button
          type="primary"
          plain
          icon="el-icon-top-right"
          size="mini"
          @click="exportData()"
          :disabled="responseData.list.length == 0"
          >导出</el-button
        >
        <el-button
          type="primary"
          plain
          icon="el-icon-download"
          size="mini"
          @click="$Common.fileDownloads('files/20200918/user.xlsx')"
          >下载模版</el-button
        >
      </div>
      <div class="search_box">
        <el-select
          v-model="requestData.departmentId"
          placeholder="请选择部门"
          size="mini"
        >
          <el-option
            v-for="(value, key) in departmentList"
            :key="key"
            :label="value.departmentName"
            :value="value.departmentId"
          >
            {{ value.departmentName }}
          </el-option>
        </el-select>
        &nbsp;&nbsp;
        <el-input
          v-model.trim="requestData.userPhone"
          placeholder="请输入手机号"
          size="mini"
        ></el-input>
        &nbsp;&nbsp;
        <el-input
          v-model.trim="requestData.userName"
          placeholder="请输入昵称"
          size="mini"
        ></el-input>
        &nbsp;&nbsp;
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          plain
          @click="searchData()"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="responseData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40" align="center">
          </el-table-column>
          <el-table-column label="序号" width="70" align="center">
            <template slot-scope="scope">
              {{
                responseData.pageSize * (responseData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column prop="Name" align="center" label="名称">
          </el-table-column>
          <el-table-column
            prop="headPortrait"
            label="人像信息"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <div class="demo-image__preview">
                <el-image
                  style="width: 60px; height: 60px;border-radius: 4px"
                  :src="$store.state.config.fileUrl + scope.row.headPortrait"
                  :preview-src-list="[
                    $store.state.config.fileUrl + scope.row.headPortrait
                  ]"
                  v-if="scope.row.headPortrait != ''"
                >
                </el-image>
                <el-image
                v-else
                  style="width: 60px; height: 60px;border-radius: 4px;"
                  :src="require('@/assets/img/noData/no_img.png')"
                  :preview-src-list="[
                    require('@/assets/img/noData/no_img.png')
                  ]"
                >
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="userInfo.eduBuresuType == -1"
            prop="jobNumber"
            label="工号"
            align="center"
            width="200"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="!scope.row.isEditJob">
                <span v-if="scope.row.jobNumber.length < 32">
                  {{ scope.row.jobNumber ? scope.row.jobNumber : "" }}
                </span>
                <span v-else>
                  暂无工号
                </span>
              </div>
              <el-input
                v-else
                :maxlength="6"
                v-model="scope.row.jobNumber"
                size="small"
                clearable
                placeholder="请输入工号（六位）"
              ></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column
            v-if="userInfo.eduBuresuType != -1"
            prop="loginId"
            label="登录账号"
            align="center"
          >
            <template slot-scope="scope">
              <el-tooltip placement="top" effect="light">
                <div slot="content">点击复制</div>
                <span
                  class="tag-read copy-span"
                  :data-clipboard-text="scope.row.loginId"
                  @click="clickCopy"
                  >{{ scope.row.loginId }}</span
                >
              </el-tooltip>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="phone"
            label="登录账号"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="roleName"
            align="center"
            label="所属角色"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="departmentName"
            align="center"
            label="所属部门"
          >
          </el-table-column>
          <el-table-column
            prop="accountStatus"
            align="center"
            label="状态"
            width="100"
          >
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.accountStatus == 1 ? 'success' : 'danger'"
                >{{
                  $store.state.select.authorityStatus[scope.row.accountStatus]
                }}</el-tag
              >
            </template>
          </el-table-column>

          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <div
                v-if="
                  userInfo.eduBuresuType == -1 && scope.row.isEditJob == true
                "
              >
                <el-link
                  class="link_box"
                  type="primary"
                  :underline="false"
                  @click="addJob(scope.row)"
                  >确认</el-link
                >
                <el-divider direction="vertical"></el-divider>
                <el-link
                  class="link_box"
                  type="primary"
                  :underline="false"
                  @click="cencelJob()"
                  >取消</el-link
                >
              </div>
              <div v-else>
                <el-link
                  type="primary"
                  @click="getDataDetails(scope.row.id)"
                  :disabled="scope.row.isEditJob == true ? true : false"
                  :underline="false"
                  >编辑</el-link
                >
                <el-divider direction="vertical"></el-divider>
                <el-dropdown>
                  <span class="el-dropdown-link">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      class="dropdown_item_box"
                      v-if="scope.row.accountStatus == 1"
                      ><el-link
                        class="link_box"
                        type="primary"
                        :underline="false"
                        :disabled="
                          userInfo.loginId == scope.row.loginId ? true : false
                        "
                        @click="setStatusTwo(scope.row)"
                        >禁用</el-link
                      ></el-dropdown-item
                    >
                    <el-dropdown-item class="dropdown_item_box" v-else
                      ><el-link
                        class="link_box"
                        type="primary"
                        :underline="false"
                        :disabled="
                          userInfo.loginId == scope.row.loginId ? true : false
                        "
                        @click="setStatusOne(scope.row)"
                        >启用</el-link
                      ></el-dropdown-item
                    >
                    <el-dropdown-item class="dropdown_item_box"
                      ><el-link
                        class="link_box"
                        type="primary"
                        :underline="false"
                        @click="delData([scope.row])"
                        >删除</el-link
                      ></el-dropdown-item
                    >
                    <el-dropdown-item
                      class="dropdown_item_box"
                      v-if="userInfo.eduBuresuType == -1"
                    >
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="每天只能修改一次，请谨慎修改！"
                        placement="top"
                        ><el-link
                          class="link_box"
                          type="primary"
                          :underline="false"
                          @click="editJob(scope.row)"
                          >工号-编辑/添加</el-link
                        >
                      </el-tooltip></el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div>
      <el-dialog
        title="新增教师"
        :visible.sync="addBox"
        direction="ltr"
        :append-to-body="true"
 width="800px"

        @close="drawerClose"
        :wrapperClosable="false"
        :close-on-press-escape="false"
      >
          <teacher-info-add
            ref="addTeacher"
            :addBox="addBox"
            :defaultData="addData"
            :roleListData="roleListData"
            :departmentList="departmentList"
            :jobListData="jobListData"
            @addSubmit="addSubmit"
            @addCencel="addCencel"
          ></teacher-info-add>
    
      </el-dialog>
      <!-- 编辑数据 -->
      <el-dialog
        title="编辑教师信息"
        :visible.sync="editBox"
        direction="ltr"
        :append-to-body="true"
        width="800px"
        :wrapperClosable="false"
        :close-on-press-escape="false"
        @close="drawerClose"
      >
          <teacher-info-edit
            ref="editTeacher"
            :editBox="editBox"
            :defaultData="editData"
            :roleListData="roleListData"
            :departmentList="departmentList"
            :jobListData="jobListData"
            @editSubmit="editSubmit"
            @editCencel="editCencel"
          ></teacher-info-edit>
 
      </el-dialog>
    </div>
  </div>
</template>

<script>
import theNoAuthority from "@/components/theNoAuthority";
import TeacherStudentsMenu from "@/components/TeacherStudentsMenu";
import TeacherInfoAdd from "./components/TeacherInfoAdd";
import TeacherInfoEdit from "./components/TeacherInfoEdit";
export default {
  name: "",
  components: {
    theNoAuthority,
    TeacherStudentsMenu,
    TeacherInfoAdd,
    TeacherInfoEdit
  },
  props: {},
  data() {
    return {
      // 有无权限
      authority: true,
      departmentList: [],
      thisDepartment: "",

      requestData: {
        pageSize: 20,
        pageNum: 1,
        schoolId: this.$store.state.schoolId,
        departmentId: "",
        userPhone: "",
        userName: ""
      },
      responseData: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },
      addData: {
        roleId: "",
        userName: "",
        userPhone: "",
        userPwd: "",
        departmentId: "",
        userIdNumber: "",
        landlineNumber: "",
        email: "",
        sex: 0,
        headPortrait: "",
        leaderOrNot: 0,
        officeId: [],
        schoolId: this.$store.state.schoolId
      },

      editData: {
        loginId: "",
        number: "",
        userId: "",
        roleId: "",
        userPwd: "",
        userName: "",
        userPhone: "",
        departmentId: "",
        userIdNumber: "",
        landlineNumber: "",
        email: "",
        sex: 0,
        headPortrait: "",
        leaderOrNot: 0,
        officeId: []
      },

      addBox: false,
      editBox: false,
      roleListData: [],
      jobListData: [],
      rowInfos: []
    };
  },
  watch: {
    addBox() {
      if (this.addBox == true) {
        this.getRoleData();
        this.getJobList();
      }
    },
    editBox() {
      if (this.editBox == true) {
        this.getRoleData();
        this.getJobList();
      }
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    }
  },
  methods: {
    clearData() {
      (this.addData = {
        roleId: "",
        userName: "",
        userPhone: "",
        userPwd: "",
        departmentId: "",
        userIdNumber: "",
        landlineNumber: "",
        email: "",
        sex: 0,
        headPortrait: "",
        leaderOrNot: 0,
        officeId: [],
        schoolId: this.$store.state.schoolId
      }),
        (this.editData = {
          loginId: "",
          number: "",
          userId: "",
          roleId: "",
          userPwd: "",
          userName: "",
          userPhone: "",
          departmentId: "",
          userIdNumber: "",
          landlineNumber: "",
          email: "",
          sex: 0,
          headPortrait: "",
          leaderOrNot: 0,
          officeId: []
        });
    },
    handleSelectionChange(val) {
      this.rowInfos = val || [];
    },
    // 删除数据
    delData(row) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var requestData = row.map((item) => {
            return {
              userId: item.id,
              loginId: item.loginId
            };
          });
          let res = await this.$Http.delMultiTeacherData(requestData);
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getDataList();
          } else if (res.code == 101) {
          } else {
            this.$message({
              type: "error",
              message: res.messsage
            });
          }
        })
        .catch(() => {});
    },

    // 获取教师详情
    async getDataDetails(id) {
      var newParamData = {
        userId: id
      };
      let res = await this.$Http.getTeacherDetails(newParamData, true);
      if (res.code == 200) {
        this.editData.loginId = res.data.loginId;
        this.editData.number = res.data.number;
        this.editData.userId = res.data.userId;
        this.editData.roleId = res.data.roleId;
        this.editData.userPwd = "";
        this.editData.userName = res.data.userName;
        this.editData.userPhone = res.data.userPhone;
        this.editData.departmentId = res.data.departmentId;
        this.editData.userIdNumber = res.data.userIdNumber;
        this.editData.landlineNumber = res.data.landlineNumber;
        this.editData.email = res.data.email;
        this.editData.sex = res.data.sex;
        this.editData.headPortrait = res.data.headPortrait;
        this.editData.leaderOrNot = res.data.leaderOrNot;
        var officeId = [];
        res.data.officeList.forEach((item) => {
          officeId.push(item.positionId);
        });
        this.editData.officeId = officeId;
        // console.log(this.editData);
        this.editBox = true;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    // 账号启用
    async setStatusOne(info) {
      var newParamData = {
        userId: info.id,
        loginId: info.loginId,
        type: 1
      };
      let res = await this.$Http.disableOrEnableUser(newParamData, true);
      if (res.code == 200) {
        this.getDataList();
        this.$message({
          type: "success",
          message: res.messsage
        });
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    // 账号禁用
    async setStatusTwo(info) {
      var newParamData = {
        userId: info.id,
        loginId: info.loginId,
        type: 2
      };
      let res = await this.$Http.disableOrEnableUser(newParamData, true);
      if (res.code == 200) {
        this.getDataList();
        this.$message({
          type: "success",
          message: res.messsage
        });
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取职务列表
    async getJobList() {
      var newParamData = {
        schoolId: this.$store.state.schoolId,
        pageSize: 999999,
        pageNum: 1
      };
      let res = await this.$Http.getSchoolJobList(newParamData, true);
      if (res.code == 200) {
        this.jobListData = res.data.list || [];
      } else if (res.code == 101) {
        this.jobListData = [];
      } else {
        this.jobListData = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取角色列表
    async getRoleData() {
      let res = await this.$Http.getAllRoleData(
        {
          schoolId: this.$store.state.schoolId
        },
        true
      );
      if (res.code == 200) {
        this.roleListData = res.data || [];
      } else if (res.code == 101) {
        this.roleListData = [];
      } else {
        this.roleListData = [];
        console.log(res.messsage);
        // this.$message({
        //     type: 'error',
        //     message: res.messsage
        // });
      }
    },
    searchData() {
      this.requestData.pageNum = 1;
      this.getDataList();
    },

    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      this.getDataList();
    },

    selectFileImport() {
      document.getElementById("xlsFile").click();
    },
    // 导入数据
    async importData() {
      var fileUpload = event.target.files[0];
      if (!fileUpload) {
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "数据导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var requestData = {
        file: fileUpload
      };
      var newData = {
        schoolId: this.$store.state.schoolId,
        file: fileUpload
      };
      if (this.userInfo.eduBuresuType == -1) {
        newData.eduBuresuType = -1;
      } else {
        newData.eduBuresuType = 0;
      }
      document.getElementById("xlsFile").value = null;
      let res = await this.$Http.importTeacherArchives(newData, true);

      // console.log(res)

      loading.close();
      if (res&&res.code == 200) {
        this.$message({
          type: "success",
          message: "导入成功"
        });
        this.getDataList();
      } else if (res&&res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res&&res.messsage
        });
      }
    },
    // 导出数据
    async exportData() {
      let req = {
        schoolId: this.$store.state.schoolId
      };
      this.$Common.exportData(req, "exportTeacherArchives", "教师档案");
    },
    async addSubmit(info) {
      var newParamData = Object.assign({}, info);
      if (this.userInfo.eduBuresuType == -1) {
        newParamData.eduBuresuType = -1;
      }
      let res = await this.$Http.addTeacherData(newParamData, true);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.addBox = false;
        this.clearData();
        this.getDataList();
        this.$refs.addTeacher.$refs.ruleForm.resetFields();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    addCencel() {
      this.addBox = false;
      this.clearData();
    },
    async editSubmit(info) {
      var newParamData = Object.assign({}, info);
      delete newParamData.loginId;
      delete newParamData.number;
      if (newParamData.userPwd == "") {
        delete newParamData.userPwd;
      }
      let res = await this.$Http.editTeacherData(newParamData);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.editBox = false;
        this.clearData();
        this.getDataList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    editCencel() {
      this.editBox = false;
      this.clearData();
    },
    drawerClose() {
      this.clearData();
    },
    editJob(row) {
      if (row.jobNumber.length >= 32) {
        row.jobNumber = "";
      }
      row.isEditJob = true;
      //   一次只修改一条
      //   let data = this.dataList.list
      // this.dataList.list = data.map((item,index)=>{
      //     item.isEditJob = row.id == item.id ? true :false
      //     return item
      // })
    },
    async addJob(row) {
      let req = {
        jobNumber: row.jobNumber,
        userId: row.id
      };
      let res = await this.$Http.addJobNumber(req, true);
      if (res.code == 200) {
        this.$message({
          message: res.messsage || "添加成功",
          type: "success"
        });
        this.getDataList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage || "添加失败",
          type: "error"
        });
      }
    },
    cencelJob() {
      this.getDataList();
    },
    // 获取数据列表
    async getDataList() {
      var newParamData = this.requestData;
      let res = await this.$Http.getTeacherList(newParamData, true);
      if (res.code == 200) {
        this.responseData.pageSize = res.data.pageSize;
        this.responseData.pageNum = res.data.pageNum;
        this.responseData.total = res.data.total;
        this.responseData.pages = res.data.pages;
        let list = res.data.list || [];
        this.responseData.list = list.map((item, index) => {
          item.isEditJob = false;
          item.jobNumber = item.loginId || "";
          return item;
        });
      } else if (res.code == 101) {
        this.responseData.total = 0;
        this.responseData.list = [];
      } else if (res.code == 102) {
        this.authority = false;
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取部门列表
    async getDepartmentList() {
      var newParamData = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getTeacherDepartment(newParamData, true);
      if (res.code == 200) {
        if (res.data) {
          this.departmentList = res.data || [];
        }
      } else if (res.code == 101) {
        this.departmentList = [];
      } else {
        this.departmentList = [];
        // console.log(res.messsage);
        // this.$message({
        //     type: 'error',
        //     message: res.messsage
        // });
      }
    },
    copy() {
      var clipboard = new this.Clipboard(".tag-read");
      clipboard.on("success", (e) => {
        this.$message({
          message: "复制成功",
          type: "success"
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$message({
          message: "该浏览器不支持自动复制",
          type: "warning"
        });
        // 释放内存
        clipboard.destroy();
      });
    }
  },
  created() {},
  mounted() {
    this.getDataList();
    this.getDepartmentList();
  }
};
</script>
<style scoped></style>
